export const ND_ROOT = 'ND-Root';
export const BT_NOTICE_SUBTYPE = 'OPP-070-notice';
